const getToken = () => {
    let info = window.sessionStorage.getItem('auth');
    if (info) {
        let token = JSON.parse(info);
        return token.token;
    }
};

export default getToken;